<template>
  <div
    v-loading='loading'
    element-loading-text='数据加载中……'
    element-loading-spinner='el-icon-loading'>
    <div v-if='searchCondition.ym&&searchCondition.artist_id'>
      <el-tabs type='border-card' class='platforms-tab' :stretch='true' :tab-position='tabPosition'
               style='height: auto;' v-model='tabName' @tab-click='handleClick'>
        <template v-for='(platform,indx) in platforms'>
          <el-tab-pane :label='platform.name' :name='`${platform.code}`' :key='`${platform.code}_${indx}`'>
            <span slot='label'>
              <div class='platform-tab-label'>
                <el-avatar shape='square' :size='28' :src='platform.logo_url' @error='true'>
                  <img src='https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png' />
                </el-avatar>
                <el-tooltip class='platform-tooltip' effect='dark' :content='`${ platform.name}`' placement='right'>
                  <span class='platform_name'>{{ platform.name && platform.name.length > 2 ? platform.name.substring(0, 2) : platform.name }}</span>
                </el-tooltip>
              </div>
            </span>
            <div class='trend-table-box'>
              <div v-if='tableRows.length' class='default-table tableBox'>
                <el-table
                  :data='tableRows'
                  style='width: 100%'
                  :key='searchCondition.artist_id'
                  class='default-table trend-record-table'
                  :row-class-name='rowClassName'
                  :highlight-current-row='true'
                  @row-click='selectRow'
                  :height='tblHeight - 60'
                  border>
                  <el-table-column
                    prop='time_day'
                    label='日期'
                    min-width='90' align='center'>
                    <template slot-scope='scope'>
                      <span class='day-cell' :title='`${scope.row.nickname}(${scope.row.group_name}/${scope.row.platform_name})`'>
                        {{ scope.row.time_day }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop='group_name'
                    label='部门-组'
                    min-width='100' align='center' show-overflow-tooltip>
                    <template slot-scope='scope'>
                      <span v-if='isTotalRow(scope.row)'>-</span>
                      <span v-else>{{ scope.row.group_name || '-' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop='nickname'
                    label='红人昵称'
                    min-width='100' header-align='center' align='center' show-overflow-tooltip>
                    <template slot-scope='scope'>
                      <span v-if='isTotalRow(scope.row)'>-</span>
                      <span v-else>{{ scope.row.nickname || '-' }}</span>
                    </template>
                  </el-table-column>
                  <template v-for='column in columns'>
                    <el-table-column :prop='column.value' :key='column.value' :label='column.title'
                                     :min-width='column.width' align='right' header-align='center'
                                     :class-name='`col-${column.value}`'>
                      <template slot-scope='scope'>
                        <template v-if='isTotalRow(scope.row)'>
                          <span class='total-cell'>{{ formatCell(column, scope.row[column.value]) }}</span>
                        </template>
                        <editable-cell v-else-if='scope.row.editable'
                                       :show-input.sync='scope.row.editable'
                                       v-model='scope.row[column.value]'
                                       :placeholder="`${$utils.parseTime(scope.row.time_day,'{d}')}日${column.title}`"
                                       @change='selectInput(scope.row,column.value)'
                                       :is-input-number='true'
                                       :class="{ 'cell-error': isCellError(scope.row, column.value) }">
                          <span slot='content'>
                            <span>{{ formatCell(column, scope.row[column.value]) }}</span>
                            <i class='el-icon-edit float-right' v-if='showEditIcon && isCurrentRow(scope.row)'></i>
                          </span>
                        </editable-cell>
                        <span v-else :class="{ 'cell-error': isCellError(scope.row, column.value) }">
                          {{ formatCell(column, scope.row[column.value]) }}
                        </span>
                      </template>
                    </el-table-column>
                  </template>
                </el-table>
              </div>
              <el-empty v-else description='该红人本月还没有数据，可尝试切换平台查看' :image-size='80'></el-empty>
            </div>
          </el-tab-pane>
        </template>
      </el-tabs>
    </div>

    <div v-else class='trend-empty-tip'>
      <el-empty description='请先在上方选择月份并查询红人' :image-size='80'></el-empty>
    </div>

    <div v-if='logCondition.artist_id&&logCondition.platform_code&&logCondition.ym'
         style='margin-top: 20px;margin-bottom: 20px'>
      <TrendDataLog :search-condition='logCondition'></TrendDataLog>
    </div>
  </div>
</template>

<script>
import EditableCell from '@/components/EditableCell'
import { numberFormat } from '@/utils/utils'
import TrendDataLog from '@/pages/trend/TrendDataLog'

export default {
  name: 'TrendRecord',
  components: {
    EditableCell, TrendDataLog
  },
  props: {
    readOnly: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  computed: {
    tableRows() {
      if (!this.tableData || !this.tableData.length) return []
      const total = { _isTotal: true, time_day: '本月合计' }
      this.columns.forEach((column) => {
        total[column.value] = this.tableData.reduce((sum, row) => {
          const v = Number(row[column.value])
          return sum + (isNaN(v) ? 0 : v)
        }, 0)
      })
      return this.tableData.concat([total])
    }
  },
  data() {
    return {
      logCondition: {
        artist_id: null,
        nickname: null,
        ym: null,
        platform_code: null,
        platform_name: ''
      },
      searchCondition: {},
      tblHeight: 500,
      showEditIcon: true,//是否显示编辑按钮
      loading: false,
      tableData: [],
      loadingStatus: false,
      tabPosition: 'left',
      tabName: '',
      platforms: [],//全部平台
      showPlatforms: [],//显示的平台
      offset: 0,
      activeNames: [],
      columns: [
        { value: 'total_num', title: '总粉丝数', width: 100, kind: 'int' },
        { value: 'add_num', title: '新增粉丝数', width: 120, kind: 'int' },
        { value: 'content_add_num', title: '内容增粉数', width: 120, kind: 'int' },
        { value: 'promotion_add_num', title: '推广增粉数', width: 120, kind: 'int' },
        { value: 'promotion_cost', title: '涨粉投放', width: 110, kind: 'money' },
        { value: 'price', title: '粉丝单价', width: 100, kind: 'money' },
        { value: 'ad_repair', title: '广告维护', width: 100, kind: 'money' },
        { value: 'live_preheat', title: '直播预热', width: 100, kind: 'money' },
        { value: 'add_works_num', title: '新增作品数', width: 100, kind: 'int' },
        { value: 'total_works_num', title: '总作品数', width: 100, kind: 'int' }
      ],
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      fields: [
        'total_num',
        'add_num',
        'content_add_num',
        'promotion_add_num',
        'promotion_cost',
        'price',
        'ad_repair',
        'live_preheat',
        'add_works_num',
        'total_works_num'
      ],
      currentRow: {},//当前选中的行
      currentColumn: {},//当前选中的列
      currentArtist: {}
    }
  },
  created() {
    const tblHeight = window.document.body.clientHeight
    this.tblHeight = tblHeight - 200
  },
  mounted() {
    // 监听 ctrl+v键盘事件
    document.addEventListener('paste', this.getPasteText, false)
  },
  beforeDestroy() {
    document.removeEventListener('paste', this.getPasteText, false)
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    showEditCell(day) {
      const currDate = new Date()
      currDate.setDate(currDate.getDate() - 1)
      let lastDay = `${currDate.getFullYear()}-${currDate.getMonth() + 1}-${currDate.getDate()}`
      lastDay = this.$utils.parseTime(lastDay, '{y}-{m}-{d}')
      return lastDay === day
    },
    moneyFormat(value) { // 金额 格式化
      return numberFormat(value, 2, '.', ',', 'round')
    },
    numFormat(value) { // 数值 格式化
      return numberFormat(value, 0, '.', ',', 'round')
    },
    isTotalRow(row) {
      return !!row._isTotal
    },
    isCurrentRow(row) {
      return !!this.currentRow && this.currentRow === row
    },
    isCellError(row, field) {
      return !!(row && row._errors && row._errors[field])
    },
    formatCell(column, value) {
      if (value === null || value === undefined || value === '') return '-'
      const num = Number(value)
      if (isNaN(num)) return value
      return column.kind === 'money' ? this.moneyFormat(num) : this.numFormat(num)
    },
    // 处理搜索条件
    handleSearchCondition() {
      const condition = {}
      if (this.searchCondition.artist_id) {
        condition.artist_id = this.searchCondition.artist_id
      }
      if (this.searchCondition.ym) {
        condition.ym = this.searchCondition.ym
      }
      if (this.tabName) {
        condition.platform_code = this.tabName
      }
      return condition
    },
    async show(query) {
      this.searchCondition = query
      await this.changeTabs()
    },
    async initData() {
      const searchCondition = this.handleSearchCondition()
      this.tableData = []
      if (searchCondition.ym && searchCondition.artist_id && searchCondition.platform_code) {
        this.logCondition.ym = searchCondition.ym
        this.loading = true
        //已录入的数据
        const { list } = await this.$api.getTrendDatumMonthList(searchCondition)
        list.map((item) => {
          item.editable = this.showEditCell(item.time_day)
          item._errors = {}
        })
        this.tableData = list || []
        this.loading = false
      }
    },
    //保存单元格数据
    async saveCell(row, field) {
      let data = {}
      if (row.id) {
        data['id'] = row.id
        data[field] = row[field]
        data._current_field = field
      } else {
        data = { ...row, ...{ _current_field: field } }
      }

      const id = await this.$api.saveTrendDatum(data)
      if (id) {
        row.id = id
        if (row._errors) {
          this.$set(row._errors, field, false)
        }
      } else {
        row[field] = null
        if (!row._errors) {
          this.$set(row, '_errors', {})
        }
        this.$set(row._errors, field, true)
        this.$notify.error('保存失败！')
      }
    },
    selectInput(row, field) {
      if (row[field] && row[field].length > 0) {
        this.saveCell(row, field)
      } else {
        row[field] = 0
        this.saveCell(row, field)
      }
    },
    rowClassName({ row }) {
      const cls = []
      if (this.isTotalRow(row)) {
        cls.push('is-total')
        return cls.join(' ')
      }
      const today = this.todayStr()
      const yesterday = this.yesterdayStr()
      if (row.time_day === today) cls.push('is-today')
      else if (row.time_day === yesterday) cls.push('is-yesterday')
      if (row.editable) cls.push('is-editing')
      return cls.join(' ')
    },
    todayStr() {
      return this.$utils.parseTime(new Date(), '{y}-{m}-{d}')
    },
    yesterdayStr() {
      const d = new Date()
      d.setDate(d.getDate() - 1)
      return this.$utils.parseTime(d, '{y}-{m}-{d}')
    },
    getLastDays(days) {
      const day1 = new Date()
      day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000 * days)
      return day1.getTime()
    },
    activateRow(row) {
      if (this.isTotalRow(row)) return
      this.currentRow = row
      this.tableData.forEach((r) => {
        if (r !== row && r.editable) {
          this.$set(r, 'editable', false)
        }
      })
      if (!row.editable) {
        this.$set(row, 'editable', true)
      }
    },
    //获取选中单元格信息
    selectRow(row, column) {
      this.currentColumn = column
      this.activateRow(row)
    },
    // 获取粘贴文本处理：若有多列数据，则询问确认粘贴开始列
    getPasteText(event) {
      const clipboardData = (event.clipboardData || window.clipboardData)
      const text = clipboardData.getData('text')
      const arrText = text.trim().split(/ [(\r\n)\r\n] /).join().split('\t') // 以转行符切割文本字符串
      if (arrText.length > 1) {
        const targetRow = this.currentRow
        if (!targetRow || this.isTotalRow(targetRow) || !targetRow.editable) {
          this.$message('请先点击要粘贴的目标行进入编辑，再粘贴入数据')
          return
        }
        //当前列的字段
        const field = this.currentColumn.property
        const label = this.currentColumn.label || '未知'
        const startIndex = this.fields.indexOf(field)
        let fields = this.fields
        const pasteText = arrText.join('\t')
        let confirmMsg = `整行列粘贴：[${pasteText}]，是否确认?`
        //计算从哪列开始填充
        if (startIndex > -1) {
          //若选中的是可填充列，则从选中列开始往后填充，否则，填充整列
          const len = arrText.length
          fields = this.fields.slice(startIndex, len + startIndex)
          confirmMsg = `从列【${label}】开始粘贴：[${pasteText}]，是否确认?`
        }

        this.$confirm(confirmMsg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          try {
            this.saveRow(fields, arrText, targetRow)
          } catch (e) {
            // 粘贴err
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      }
    },
    async saveRow(fields, arrText, row) {
      //粘贴之后请求剪切板
      navigator.clipboard.writeText('')
      const index = this.tableData.indexOf(row)
      for (let i = 0; i < fields.length; i++) {
        const f = fields[i]
        this.tableData[index][f] = arrText[i].trim()
      }
      this.$notify.info('数据保存中...')
      for (let i = 0; i < fields.length; i++) {
        const f = fields[i]
        await this.saveCell(this.tableData[index], f)
      }
      this.$notify.success('数据已保存，请核对数据准确性')
    },
    handleClick(tab) {
      //切换平台触发
      this.tabName = tab.name
      this.logCondition.platform_code = tab.name
      this.logCondition.platform_name = tab.label

      this.initData()
    },
    async changeTabs() {
      if (this.searchCondition.artist_id) {
        this.logCondition.artist_id = this.searchCondition.artist_id
        const { list } = await this.$api.getArtistOwnedPlatforms(this.searchCondition.artist_id)
        if (list) {
          this.platforms = list
          if (list[0]) {
            const firstPlatform = list[0]
            this.handleClick({ name: firstPlatform.code, label: firstPlatform.name })
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.trend-table-box {
  min-height: 60vh;
}

.trend-record-table .cell-error .el-input__inner,
.trend-record-table .cell-error {
  color: #f56c6c !important;
}
.trend-record-table .cell-error .el-input__inner {
  border-color: #f56c6c;
}

.trend-empty-tip {
  padding: 20px 0;
}
</style>

<style>
/* 平台垂直 Tab 精修 —— 页面级独立命名空间，不影响其它页面 */
.platforms-tab > .el-tabs__header .platform-tab-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
}

.platforms-tab > .el-tabs__header .el-tabs__item {
  height: 78px;
  padding: 8px 10px;
  margin: 2px 0;
  line-height: 20px;
  font-size: 12px;
  text-align: center;
  transition: background-color .2s ease, color .2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.platforms-tab > .el-tabs__header .el-tabs__item .platform_name {
  max-width: 56px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: inherit;
}

.platforms-tab > .el-tabs__header .el-tabs__item:hover {
  color: #1890ff;
}

.platforms-tab > .el-tabs__header .el-tabs__item.is-active {
  color: #1890ff;
  background: #f6faff;
  box-shadow: inset 3px 0 0 0 #1890ff;
  font-weight: 600;
}

.platforms-tab .el-tabs__content {
  padding: 12px;
}

/* 今日 / 昨日 / 编辑中 / 合计 行高亮 */
.trend-record-table .el-table__row.is-today > td {
  background-color: #f0f9ff !important;
}
.trend-record-table .el-table__row.is-yesterday > td {
  background-color: #fdf6ec !important;
}
.trend-record-table .el-table__row.is-editing > td {
  background-color: #fffbe6 !important;
}
.trend-record-table .el-table__row.is-total > td {
  background-color: #f5f7fa !important;
  font-weight: 600;
  color: #303133;
}
</style>
